var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9331 61.1662L35.2664 69.1662C36.5998 70.4996 39.5998 71.1662 41.5998 71.1662H54.2664C58.2664 71.1662 62.5998 68.1662 63.5998 64.1662L71.5998 39.8329C73.2664 35.1662 70.2664 31.1662 65.2664 31.1662H51.9331C49.9331 31.1662 48.2664 29.4996 48.5998 27.1662L50.2664 16.4996C50.9331 13.4996 48.9331 10.1662 45.9331 9.16623C43.2664 8.16623 39.9331 9.49957 38.5998 11.4996L24.9331 31.8329",
    stroke: "url(#paint0_linear_676_80)",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93311 61.166V28.4993C7.93311 23.8327 9.93311 22.166 14.5998 22.166H17.9331C22.5998 22.166 24.5998 23.8327 24.5998 28.4993V61.166C24.5998 65.8327 22.5998 67.4993 17.9331 67.4993H14.5998C9.93311 67.4993 7.93311 65.8327 7.93311 61.166Z",
    stroke: "url(#paint1_linear_676_80)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_676_80",
    x1: 24.9331,
    y1: 42.334,
    x2: 72.0627,
    y2: 42.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A71F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_676_80",
    x1: 7.93311,
    y1: 46.5327,
    x2: 24.5998,
    y2: 46.5327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8A71F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCE623"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.baf63514a6c1b8dbd4989d383db17268.svg";
export { ForwardRef as ReactComponent };